import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Segmented, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@client/store/theme.store';
import { applyThemeAttribute, setStoredTheme } from '@client/utils/theme.util';
import { EThemeMode } from '@common/types';

export default function ThemeSwitcher(): React.JSX.Element {
  const { mode, setMode, resolved } = useTheme();
  const { t } = useTranslation();

  const handleChange = (value: string | number) => {
    const next = value as EThemeMode;
    setMode(next);
    setStoredTheme(next);
    const applied =
      next === EThemeMode.SYSTEM ? resolved : (next as EThemeMode);
    applyThemeAttribute(applied);
  };

  return (
    <Tooltip title={t('theme.tooltip')}>
      <Segmented
        value={mode}
        onChange={handleChange}
        options={[
          {
            value: EThemeMode.LIGHT,
            icon: <SunOutlined />,
            title: t('theme.light'),
          },
          {
            value: EThemeMode.DARK,
            icon: <MoonOutlined />,
            title: t('theme.dark'),
          },
          {
            value: EThemeMode.SYSTEM,
            icon: <DesktopOutlined />,
            title: t('theme.system'),
          },
        ]}
      />
    </Tooltip>
  );
}
